import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, View, type StyleType} from "@khanacademy/wonder-blocks-core";
import type {GuideIconReaction} from "@repo/guide-utils";
import {staticUrl} from "@repo/urls";

const StyledImg = addStyle("img");

interface Props {
    id: GuideIconReaction;
    style?: StyleType;
}

/**
 * Renders an image based on the provided reaction id..
 */
export const MessageIconReaction = ({id, style}: Props): React.ReactElement => (
    <View style={style} testId="message-icon-reaction">
        <StyledImg
            // This is purely visual, so we don't need to worry about alt text.
            // Screen readers should ignore this, as they can read the
            // associated chat message to tell how the Guide is reacting.
            alt=""
            style={styles.image}
            src={staticUrl(`/images/guide/chat-reactions/${id}.gif`)}
        />
    </View>
);

const styles = StyleSheet.create({
    image: {
        width: "100%",
        height: "auto",
    },
});
